const ReferenceSubmit = () => {
	return (
		<div className='flex h-screen flex-col items-center justify-center gap-2'>
			<h3>Reference Check Sent Successfully</h3>
			<p>Now you can close this tab.</p>
		</div>
	);
};

export default ReferenceSubmit;
